import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SecondaryButton from '../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import * as XLSX from 'xlsx';
import { DownloadContainer, DropdownMenu } from './TrainingList.styles';
import TertiaryButton from '../../Components/Buttons/TertiaryButton/TertiaryButton.component';

const ExportData = ({ courses, allUsers }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const exportToCSV = () => {
    const headers = ['User', ...courses.map((course) => course.courseName)];
    const rows = allUsers.map((user) => {
      const userRow = [`${user?.firstName} ${user?.lastName}`];
      courses.forEach((course) => {
        const userCourse = user.courses?.find(
          (userCourse) => userCourse.courseId === course._id
        );

        let status = 'Course Not Assigned';
        if (userCourse) {
          if (new Date(userCourse.expiryDate) < new Date()) {
            status = 'Expired';
          } else if (!userCourse.complete) {
            status = 'In Progress';
          } else if (userCourse.complete) {
            status = 'Completed';
          }
        }
        userRow.push(status);
      });
      return userRow;
    });

    const csvContent = [
      headers.join(','),
      ...rows.map((row) => row.join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'training_list.csv';
    link.click();
  };

  const exportToExcel = () => {
    const headers = ['User', ...courses.map((course) => course.courseName)];
    const rows = allUsers.map((user) => {
      const userRow = [`${user?.firstName} ${user?.lastName}`];
      courses.forEach((course) => {
        const userCourse = user.courses?.find(
          (userCourse) => userCourse.courseId === course._id
        );

        let status = 'Course Not Assigned';
        if (userCourse) {
          if (new Date(userCourse.expiryDate) < new Date()) {
            status = 'Expired';
          } else if (!userCourse.complete) {
            status = 'In Progress';
          } else if (userCourse.complete) {
            status = 'Completed';
          }
        }
        userRow.push(status);
      });
      return userRow;
    });

    const worksheetData = [headers, ...rows]; // Combine headers and rows
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData); // Create worksheet
    const workbook = XLSX.utils.book_new(); // Create workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Training List'); // Append worksheet

    XLSX.writeFile(workbook, 'training_list.xlsx'); // Save Excel file
  };

  return (
    <DownloadContainer>
      <TertiaryButton functionName={toggleDropdown} span="Download Info" />
      {/* <DropdownButton onClick={toggleDropdown}>Download Info</DropdownButton> */}
      {showDropdown && (
        <DropdownMenu>
          <SecondaryButton span="Export to CSV" functionName={exportToCSV} />
          <SecondaryButton
            span="Export to Excel"
            functionName={exportToExcel}
          />
        </DropdownMenu>
      )}
    </DownloadContainer>
  );
};

ExportData.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      courseName: PropTypes.string.isRequired,
    })
  ),
  allUsers: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      courses: PropTypes.arrayOf(
        PropTypes.shape({
          courseId: PropTypes.string.isRequired,
          expiryDate: PropTypes.string,
          complete: PropTypes.bool,
        })
      ),
    })
  ),
};

export default ExportData;
